import "./style.css";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>

      <p className="updated">Last updated: 13th SEP 2026</p>

      <p>
        This Privacy Policy explains how we collect, use, and protect your
        information when you use our app and services.
      </p>

      <h2>Information We Collect</h2>
      <ul>
        <li>
          <strong>Personal Information:</strong> Name, phone number, email,
          unit number (if applicable), and visitor details.
        </li>

        <li>
          <strong>Device Information:</strong> Device model, OS version, and
          app usage logs.
        </li>

        <li>
          <strong>Access & Security Data:</strong> QR code scans, LPR
          (License Plate Recognition) checks, access timestamps, and booking
          details.
        </li>

        <li>
          <strong>Location Information:</strong> The app may collect the
          device's latitude and longitude only when an employee performs an
          attendance or clock-in/clock-out action. Location information is
          used to verify the employee's attendance location and is not
          continuously tracked.
        </li>
      </ul>

      <h2>Location Data and Attendance</h2>
      <p>
        Location access is used specifically for attendance verification.
        When an employee records attendance, the app may obtain the device's
        current latitude and longitude and associate this information with
        the attendance record.
      </p>

      <p>
        The app does not continuously monitor or track the employee's location
        when attendance is not being recorded. Location data is not collected
        for general browsing or other activities within the app.
      </p>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To provide visitor management services (VMS).</li>
        <li>
          To record and verify employee attendance using attendance
          timestamps and, where applicable, location coordinates.
        </li>
        <li>
          To manage bookings, deliveries, pick-up/drop-off, and access
          control.
        </li>
        <li>To improve app performance and security.</li>
        <li>To assist security officers and property management.</li>
      </ul>

      <h2>Data Sharing</h2>
      <p>
        We do not sell your personal data or location information. Information
        may be shared only with authorized security staff, management, and
        service providers who are required to operate and support the app.
      </p>

      <h2>Data Protection</h2>
      <p>
        We use appropriate security measures, including encryption, secure
        servers, and restricted access controls, to safeguard your personal,
        attendance, and location information.
      </p>

      <h2>Data Retention</h2>
      <p>
        Personal information, attendance records, and location information
        associated with attendance may be retained for as long as reasonably
        necessary for attendance management, security, operational,
        contractual, or legal purposes.
      </p>

      <h2>Your Rights</h2>
      <ul>
        <li>Request access to your data.</li>
        <li>Request correction or deletion of your data, where applicable.</li>
        <li>Request information about how your data is used.</li>
        <li>Contact us for support or data-related questions.</li>
      </ul>

      <h2>Location Permission</h2>
      <p>
        On iPhone, the app may request permission to access your location when
        location information is required for attendance. You can manage
        location permissions for the app through your iPhone settings.
      </p>

      <p>
        If location permission is denied or disabled, attendance functionality
        that requires location verification may not work as intended.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have questions about this Privacy Policy or your data, contact
        us at:
      </p>

      <p>
        <strong>Email:</strong> sales@innovationsolutions.net
      </p>

      <p>
        <strong>Website:</strong> https://innovationsolutions.net/
      </p>
    </div>
  );
}